"use client"
import type { CSSProperties, ReactNode } from "react"
import Link from "@/lib/navigation"
import { usePathname } from "@/lib/navigation"
import { House as Home, FileText, Gear as Settings, FadersHorizontal as SlidersHorizontal, Leaf } from "@phosphor-icons/react"
import { ThemeToggle } from "@/components/theme-toggle"
import "./user-portal.css"
import "./compact-user.css"
import "./portal-scroll.css"
import "./portal-overlays.css"
import "./portal-motion.css"
import "./portal-nav-glider.css"

const destinations = [
  { href: "/user/dashboard", label: "首页", icon: Home },
  { href: "/user/logs", label: "日志", icon: FileText },
  { href: "/user/account", label: "配置", icon: SlidersHorizontal },
  { href: "/user/settings", label: "设置", icon: Settings },
]
export function UserPortalShell({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const title = destinations.find(item => item.href === pathname)?.label || "用户中心"
  const activeIndex = Math.max(0, destinations.findIndex(item => item.href === pathname))
  const pageKey = destinations[activeIndex]?.href.split("/").pop() || "dashboard"
  return <div className="user-portal dashboard-shell" data-page={pageKey}>
    <div className="portal-bottom-fade" aria-hidden="true" />
    <nav className="portal-nav" aria-label="用户导航">
      <div className="portal-nav-brand"><Leaf size={24} />艾艾代肝小店</div>
      {destinations.map(({ href, label, icon: Icon }) => <Link key={href} href={href} aria-current={pathname === href ? "page" : undefined}><Icon size={20} /><span>{label}</span></Link>)}
      <span className="portal-nav-glider" style={{ "--portal-nav-index": activeIndex } as CSSProperties} aria-hidden="true" />
      <div className="portal-nav-foot">博士的作战空间</div>
    </nav>
    <div className="portal-scroll dashboard-scroll"><div className="portal-container">
      <header className="portal-top"><span className="portal-mobile-brand"><Leaf size={22} />艾艾代肝小店</span><span className="portal-desktop-title">用户中心 / {title}</span><ThemeToggle /></header>
      <main className="dashboard-content">{children}</main>
    </div></div>
  </div>
}
